import { Small } from '@bigcommerce/big-design';

export default function CustomerAddressSummary({ address }) {
	if (
		!address?.address1 ||
		!address?.city ||
		!address?.state_or_province ||
		!address?.postal_code
	)
		return <Small>Address Incomplete</Small>;

	return (
		<>
			<div>{address.address1}</div>
			<div>
				{address.city}, {address.state_or_province},{' '}
				{address.postal_code}
			</div>
		</>
	);
}
